<template>
  <div class="home">
    <div
      class="background"
      :style="{
        backgroundImage: 'url(' + require('@/assets/img/mayologobg2.png') + ')'
      }"
    ></div>
    <div class="logo">
      <img src="@/assets/img/mayologo.png" />
    </div>
    <div class="menu">
      <div class="left-bg">
        <div class="left">
          <h1>Additive Manufacturing</h1>
          <div class="line"></div>
          <div class="menu-item">
            <p
              id="overview"
              @click="toggleActive"
              :class="{ active: current === 'overview' }"
            >
              What is Additive Manufacturing?
            </p>
            <img src="@/assets/img/go.png" />
          </div>

          <div class="menu-item">
            <p
              id="manufacturing"
              @click="toggleActive"
              :class="{ active: current === 'manufacturing' }"
            >
              Common types of 3d printing
            </p>
            <img src="@/assets/img/go.png" />
          </div>

          <div class="menu-item">
            <p
              id="equipment"
              @click="toggleActive"
              :class="{ active: current === 'equipment' }"
            >
              Additive manufacturing in medicine
            </p>
            <img src="@/assets/img/go.png" />
          </div>
        </div>
      </div>

      <div class="right">
        <transition>
          <div class="overview" v-if="current === 'overview'">
            <h3>What is Additive Manufacturing?</h3>
            <p>
              Additive Manufacturing, or 3D Printing, is a process of creating
              three dimensional objects from a digital file.
            </p>
            <p>
              The creation process is achieved through laying down successive
              layers of material until the object is created.
            </p>
            <p>
              Each layer can be seen as an extremely thin horizontal cross
              section of the object.
            </p>
          </div>
        </transition>

        <transition>
          <div class="manufacturing" v-if="current === 'manufacturing'">
            <h3>Select a technology Below to learn more</h3>

            <!-- TECHNOLOGIES -->
            <div class="inner-nav">
              <div class="card" @click="popup = 7">
                <p>Fused Filament Fabrication (FFF)</p>
              </div>

              <div class="card" @click="popup = 8">
                <p>Stereolithography (SLA)</p>
              </div>

              <div class="card" @click="popup = 9">
                <p>Direct Metal Laser Sintering (SLS)</p>
              </div>

              <div class="card" @click="popup = 10">
                <p>Multi-Jet Fusion (MJF)</p>
              </div>
            </div>
            <!-- END OF TECHNOLOGIES -->

            <!-- TECHNOLOGY POPUPS -->
            <!-- Fused Filament Fabrication (FFF) -->
            <div v-if="popup == 7" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Fused Filament Fabrication (FFF)</h3>
                  <div class="line2"></div>
                  <p>
                    Fused Filament Fabrication, also known as Fused Deposition
                    Modeling (FDM), is an additive manufacturing technology that
                    creates objects by extruding material in very thin layers.
                    Each layer can be seen as a cross section of the object
                    being printer.
                  </p>
                  <p>Which of our Printers use this Technology?</p>
                  <li>Markforged Mark Two</li>
                  <li>Stratasys Fortus 400mc (FDM)</li>
                  <li>Stratasys F370 (FDM)</li>
                </div>
              </div>
            </div>
            <!-- END Fused Filament Fabrication (FFF) -->

            <!-- Stereolithography (SLA) -->
            <div v-if="popup == 8" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Stereolithography (SLA)</h3>
                  <div class="line2"></div>
                  <p>
                    Stereolithography technology creates objects by a process
                    called vat polymerization. Objects are built using a light
                    source, typically a laser or projector, to cure liquid resin
                    into a hard plastic.
                  </p>
                  <p>Which of our Printers use this Technology?</p>
                  <li>Formlabs Form 3</li>
                </div>
              </div>
            </div>
            <!-- END Stereolithography (SLA) -->

            <!-- Direct Metal Laser Sintering (SLS) -->
            <div v-if="popup == 9" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Direct Metal Laser Sintering (SLS)</h3>
                  <div class="line2"></div>
                  <p>
                    Direct Metal Laser Sintering is a process used to turn
                    metallic powder into functional metal prototypes and
                    production parts. The technology utilizes a laser to
                    micro-weld cross-sections of powder, layer by layer, until
                    the build is finished
                  </p>
                  <p>Which of our Printers use this Technology?</p>
                  <li>EOS M290 Titanium Printer</li>
                </div>
              </div>
            </div>
            <!-- END Direct Metal Laser Sintering (SLS) -->

            <!-- Multi-Jet Fusion (MJF) -->
            <div v-if="popup == 10" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Multi-Jet Fusion (MJF)</h3>
                  <div class="line2"></div>
                  <p>
                    Multi-Jet Fusion is a 3D printing technology which builds
                    functional prototypes and end-use production parts from
                    nylon powder. Rather than using a laser to sinter the
                    powder, MJF uses an inkjet array to apply fusion agents to
                    the bed of nylon powder and a heating element to fuse each
                    layer.
                  </p>
                  <p>Which of our Printers use this Technology?</p>
                  <li>HP Jet Fusion 580</li>
                </div>
              </div>
            </div>
            <!-- END Multi-Jet Fusion (MJF) -->
          </div>
        </transition>

        <transition>
          <div class="equipment" v-if="current === 'equipment'">
            <h3>Select a technology Below to learn more</h3>

            <!-- TECHNOLOGIES -->
            <div class="inner-nav">
              <div class="card" @click="popup = 11">
                <p>Anatomic Models</p>
              </div>

              <div class="card" @click="popup = 12">
                <p>Prototype Medical Instruments</p>
              </div>

              <div class="card" @click="popup = 13">
                <p>Devices for Market Evaluation</p>
              </div>

              <div class="card" @click="popup = 14">
                <p>Patient-Specific Implants</p>
              </div>
            </div>
            <!-- END OF TECHNOLOGIES -->

            <!-- TECHNOLOGY POPUPS -->
            <!-- Fused Filament Fabrication (FFF) -->
            <div v-if="popup == 11" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info row">
                  <img src="@/assets/img/anatomic-model.png" />
                  <div class="column">
                    <h3>Anatomic Models</h3>
                    <div class="line2"></div>
                    <p>
                      Anatomic Models are used to visualize complex patient
                      anatomy. Physicians primarily use these tools for surgical
                      planning and patient education. This critical service is
                      provided by the Mayo Clinic Anatomic Modeling Lab in the
                      Department of Radiology.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- END Fused Filament Fabrication (FFF) -->

            <!-- Stereolithography (SLA) -->
            <div v-if="popup == 12" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info row">
                  <img src="@/assets/img/prototype-medical.png" />
                  <div class="column">
                    <h3>Prototype Medical Instruments</h3>
                    <div class="line2"></div>
                    <p>
                      Utilizing 3D printing, engineers quickly iterate their
                      designs in order to test functionality and make
                      improvements. This process enables the Division of
                      Engineering to efficiently deliver functional prototype
                      medical instruments.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- END Stereolithography (SLA) -->

            <!-- Direct Metal Laser Sintering (SLS) -->
            <div v-if="popup == 13" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info row">
                  <img src="@/assets/img/market-evaluation.png" />
                  <div class="column">
                    <h3>Devices for Market Evaluation</h3>
                    <div class="line2"></div>
                    <p>
                      The Division of Engineering collaborates with physicians
                      and research scientists to bring novel ideas to fruition.
                      We also partner with Mayo Clinic Ventures to provide
                      sample devices to commercial partners interested in
                      licensing Mayo Clinic intellectual property.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- END Direct Metal Laser Sintering (SLS) -->

            <!-- Multi-Jet Fusion (MJF) -->
            <div v-if="popup == 14" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info row">
                  <img src="@/assets/img/patient-specific.png" />
                  <div class="column">
                    <h3>Patient Specific Implants</h3>
                    <div class="line2"></div>
                    <p>
                      Using digital files from patient specific imaging,
                      customized implantable devices can be created that exactly
                      match a patient’s unique anatomy. This enables
                      personalized solutions to complex treatment plans, which
                      improves patient outcomes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- END Multi-Jet Fusion (MJF) -->
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: "overview",
      popup: null,
      popup2: null,
      popup: false
    };
  },
  methods: {
    toggleActive(event) {
      this.current = event.target.id;
    }
  }
};
</script>

<style scoped>
h1 {
  font-family: Palatino;
  color: #ffffff;
  font-size: 70px;
  position: relative;
  padding-top: 0px;
  width: 500px;
  text-align: center;
  font-weight: lighter;
  letter-spacing: 7px;
  text-align: left;
  margin: 0;
}
.video-modal h3 {
  font-size: 30px;
  margin-bottom: 10px;
  font-family: AzoSans;
  letter-spacing: auto;
}

h3 {
  font-family: Palatino;
  color: #ffffff;
  font-size: 50px;
  position: relative;
  padding-top: 0px;
  /* width: 500px; */
  text-align: center;
  font-weight: lighter;
  letter-spacing: 7px;
  text-align: left;
  margin: 30px 0;
}

.left {
  /* padding-left: 157px;
    flex: none;
    padding-top: 301px;
    width: 500px; */

  /* css for demo */
  /* padding-right: 120px; */
  padding-top: 235px;
  position: fixed;
  left: 200px;
}

.right {
  padding-top: 235px;
  padding-left: 600px;
  position: relative !important;
  display: flex !important;
  flex-wrap: nowrap !important;
  width: 44%;
  /* height: 100vh !important; */
  justify-content: flex-start !important;
  overflow: hidden !important;
  overflow-x: auto !important;
}

.btn {
  background-color: rgba(255, 255, 255, 0.1);
  z-index: 11;
  /* width: 100px;
  height: 50px;  */
}

.logo img {
  position: fixed;
  z-index: 11;
}

.menu {
  padding: 0;
  overflow: hidden !important;
}

.left-bg {
  width: 43%;
}

.card {
  display: flex;
  background-color: rgba(255, 255, 255, 0.3);
  width: 48%;
  margin: 1%;
  height: 165px;
  /* border: 2px solid white; */
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 10px;
}

.card p {
  position: relative;
  font-size: 33px;
  padding-bottom: 10px;
  /* padding-top: 10px; */
  color: #ffffff;
  font-family: AzoSans;
  margin: 0;
  text-align: center;
}

.sub-menu {
  overflow: hidden !important;
  overflow-x: auto !important;
}

.info.row {
  display: flex;
}

.info img {
  width: 600px;
  margin-right: 5%;
}
</style>
